module.exports = __webpack_public_path__ + "static/media/map6-5.7b0ad647.png";